module.exports = __webpack_public_path__ + "static/media/12.6bdf1067.png";